import { HttpContextToken } from '@angular/common/http';

/** Marks HTTP requests that load terminal config (see ConfigHttpLoader). */
export const CONFIG_CONTEXT = new HttpContextToken<boolean>(() => false);
